export const FETCH_AC_ALARM_DATA = 'FETCH_AC_ALARM_DATA';
export const FETCH_AC_ALARM_EVENT_DATA = 'FETCH_AC_ALARM_EVENT_DATA';
export const EXPORT_AC_ALARM_DATA = 'EXPORT_AC_ALARM_DATA';
export const FETCH_AC_ALARM_COUNT_DATA = 'FETCH_AC_ALARM_COUNT_DATA';
export const FETCH_AC_ALARM_EVENT_COUNT_DATA = 'FETCH_AC_ALARM_EVENT_COUNT_DATA';
export const CLEAR_AC_ALARM_DATA = 'CLEAR_AC_ALARM_DATA';
export const SET_AC_ALARM_HISTORY_TABLE_PROPS = 'SET_AC_ALARM_HISTORY_TABLE_PROPS';
export const SET_ACTIVE_AC_ALARM_TABLE_PROPS = 'SET_ACTIVE_AC_ALARM_TABLE_PROPS';
export const SET_AC_FILTERS_APPLIED_FROM_REDIRECTION = 'SET_AC_FILTERS_APPLIED_FROM_REDIRECTION';
export const SET_PULSE_AC_ALARM_LOADER = 'SET_PULSE_AC_ALARM_LOADER';
export const SET_AC_ALARM_LIST_REQUEST_HASH = 'SET_AC_ALARM_LIST_REQUEST_HASH';
export const SET_AC_ALARM_LIST_CARDS_REQUEST_HASH = 'SET_AC_ALARM_LIST_CARDS_REQUEST_HASH';
export const SET_PULSE_AC_ALARM_LIST_LOADER = 'SET_PULSE_AC_ALARM_LIST_LOADER';
